import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **PageEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición.
 */
export class PageEndpoint {
  /** Endpoint que apunta a la información de la pagina principal de la app web */
  static landing = `${apiUrl}page/`;
  /** Endpoint que apunta a la información de las curiosidades*/
  static curiosities = `${apiUrl}page/curiosities/`;
  /** Endpoint que apunta a la información de la primera curiosidad*/
  static firstCuriosity = `${apiUrl}page/first_curiosity/`;
  /** Endpoint que apunta a la información de las politicas de privacidad */
  static privacyPolicies = `${apiUrl}page/privacy-policy/`;
  /** Endpoint que apunta a la información de los terminos y condiciones*/
  static termsCondition = `${apiUrl}page/terms-condition/`;
  /** Endpoint que apunta a la información de una curiosidad, esta es especificada en el mismo*/
  static curiosity = `${apiUrl}page/{}/curiosities/`;
  /** Endpoint que apunta a la información de los anuncios*/
  static adversiting = `${apiUrl}page/advertising/?slug={}`;
  /** Endpoint que apunta a la información del top 10 de la página principal*/
  static topten = `${apiUrl}page/topten/`;
  /** Endpoint que apunta a la información de contacto*/
  static contact = `${apiUrl}page/contact/`;
  /** Endpoint que apunta a la información de los mensajes PQRD*/
  static sendMessage = `${apiUrl}page/contact/pqrd/`;
  /** Obtiene la información de las solicitudes PQRD para un usuario específico*/
  static getQuestions = `${apiUrl}page/contact/pqrd/?user=`;
  /** Endpoint que apunta a la información del sidebar de búsqueda*/
  static sidebarSearch = `${apiUrl}page/sidebar/search/`;
  /** Endpoint que apunta a la información del geomarcador de la ggobernación */
  static idecut = `${apiUrl}search/?marker_slug=gobernacion`;
  /** Endpoint que apunta a la información de las calificaciones o valoraciones hechas a los geomarcadores o ciudades */
  static ratings = `${apiUrl}ratings/`;
  /** Endpoint that points to the information of the geopoint types */
  static geopointTypes = `${apiUrl}geopoints/geopoint_type/`;
  /** Endpoint that points to the information of the marker categories */
  static markerCategories = `${apiUrl}geopoints/marker_category/`;
}
